import axios from 'axios'
import { API_BASE_URL, RESPONSE_CODE } from './constants'

// 创建axios实例
const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 请求超时时间
  headers: {}
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 这里可以根据后端返回的状态码进行不同的处理
    if (res.code === RESPONSE_CODE.SUCCESS || res.code === RESPONSE_CODE.SUCCESS_ALT || res.code === 0) {
      return res
    } else {
      console.error('接口错误:', res.msg || '未知错误')
      return Promise.reject(new Error(res.msg || '未知错误'))
    }
  },
  error => {
    console.error('响应错误:', error)
    return Promise.reject(error)
  }
)

// 封装GET请求
export function get(url, params) {
  return service({
    url,
    method: 'get',
    params
  })
}

// 封装POST请求
export function post(url, data) {
  return service({
    url,
    method: 'post',
    data
  })
}

// 封装上传文件的请求
export function upload(url, file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return service({
    url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export default service 